export default [
  {
    path: "/moderator-dashboard",
    name: "moderator-main",
    component: () =>
      import(
        "../../modules/BlogModerator/pages/ModeratorMain/ModeratorMain.vue"
      ),
    meta: {
      layout: "main",
      auth: true,
      role: ["moderator"],
    },
  },
];
